import { useEffect } from 'react';
import Cookie from 'js-cookie';
import styled from 'styled-components';

import { Button } from 'shared/components/Button';
import { Modal } from 'shared/components/Modal';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';
import { STORAGE } from 'shared/enums/SitePreferences';
import { useCheckoutContext } from 'checkout/providers/CheckoutContextProvider';
import { ITabName } from 'checkout/types/Tab';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Payment.ChangeCurrencyGiftCardModal';

export const ChangeCurrencyGiftCardModal = ({
  onClose,
}: {
  onClose: ({ changedCurrency }: { changedCurrency: boolean }) => void;
}) => {
  const { changeTab, order, tab, updateOrder } = useCheckoutContext();

  const handleChangeCurrency = async () => {
    Cookie.set(STORAGE.CURRENCY, 'USD');

    await updateOrder({ orderNumber: order.number, payload: { updateCurrency: true } });

    if (tab === ITabName.REVIEW) {
      changeTab(ITabName.PAYMENT);
    }

    onClose({ changedCurrency: true });
  };

  useEffect(() => {
    sendTrackingEvent('MODAL_OPEN_VIEW', {
      modal_name: 'update_currency',
    });
  }, []);

  return (
    <ChangeCurrencyGiftCardModal.Modal
      data-qa="change_currency_modal"
      onClose={() => onClose({ changedCurrency: false })}
      title={t(`${TP}.changeCurrencyTitle`, 'Update Currency')}
    >
      <ChangeCurrencyGiftCardModal.Body>
        {t(
          `${TP}.changeCurrencyGiftCardModalBody`,
          'To redeem your GOAT Gift Card, you must update your currency to USD.',
        )}
      </ChangeCurrencyGiftCardModal.Body>
      <ChangeCurrencyGiftCardModal.Cta>
        <Button data-qa="change_currency_confirm_button" onClick={handleChangeCurrency}>
          {t('checkout.changeCurrencyGiftCardOk', 'UPDATE AND REDEEM')}
        </Button>
      </ChangeCurrencyGiftCardModal.Cta>
    </ChangeCurrencyGiftCardModal.Modal>
  );
};

ChangeCurrencyGiftCardModal.Modal = styled(Modal)`
  max-width: 335px;
`;

ChangeCurrencyGiftCardModal.Body = styled.p`
  margin: 8px 0 32px;
`;

ChangeCurrencyGiftCardModal.Cta = styled.div`
  display: flex;
`;
